
import {Fetch} from "../../utils/storage"
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import {ParseTime} from "../../utils/time"
import {Api} from "../../utils/api"
import Uploader from "vux-uploader-component";


export default {
name: 'Order-detail',
components: {
Uploader,
XButton,
Flexbox,
FlexboxItem,
},
filters: {
/**
* @return {string}
*/
meetingTimeFilter(val) {
let start = ParseTime(val.StartAt,'{y}-{m}-{d}')
let end = ParseTime(val.EndAt,'{y}-{m}-{d}')
return `${start} 至 ${end}`
},

statusFilter(value) {
return {
to_pay:'待支付',
paid:'已支付',
canceled:'已取消',
refunded:'已退费',
}[value]
}
},
data () {
return {
OrderMeetingReceiptID: 0,
MeetingReceiptOrder: {},
OrderMeetingReceiptShow: false,
remoteUrl: `http://api.c64ade55d3c0c44edace4f7fe6db1d8ba.cn-beijing.alicontainer.com/auxiliary-micro/user-end/image-upload-with-prefix?owner=1&style=compress&category=order-meeting-receipt&copy=false`,
prefixName: ''
}
},
async created () {
this.OrderMeetingReceiptID = this.$route.params["orderMeetingReceiptID"]
if (!this.OrderMeetingReceiptID) this.$router.go(-1)
this.OrderMeetingReceiptID = parseInt(this.OrderMeetingReceiptID)
this.UserID = Fetch("ID")
await this.fetchOrderMeetingReceipt()
},
methods: {
ParseTime,
handleGoToOrderDetail() {
this.$router.go(-1)
},
async fetchOrderMeetingReceipt() {
let res = await Api('GetOrderMeetingReceiptList',{
Data:{
ID:this.OrderMeetingReceiptID,
},
Preloads:[
{Column:'Order.OrderInfo'}
]
})
if (res.data.List && res.data.List.length === 1) {
this.MeetingReceiptOrder = res.data.List[0]
this.MeetingReceiptOrder.FieldsData = JSON.parse(this.MeetingReceiptOrder.FieldsData)
this.MeetingReceiptOrder.FeedBackPhotos = JSON.parse(this.MeetingReceiptOrder.FeedBackPhotos)
this.MeetingReceiptOrder.fileList = []
this.changePrefixName()
} else {
this.$vux.toast.show({
text:'获取信息出错',
type:'cancel',
})
this.$router.go(-1)
}
},
handleMeetingReceiptDownload() {
if (this.MeetingReceiptOrder.ReceiptFile) {
window.location.href =this.MeetingReceiptOrder.ReceiptFile
} else {
this.$vux.toast.show({
text:'正在生成回执单中，请耐心等待'
})
}

},
handleReceiptImagesReset() {
this.MeetingReceiptOrder.FeedBackPhotos = []
},
handleReceiptImagesCancel() {
this.fetchOrderMeetingReceipt()
},
async handleReceiptImagesUpdate() {
let imageList = this.MeetingReceiptOrder.fileList.map(item => {
return item.imgUrl
})
if (imageList.length < 1){
this.$vux.toast.show({
text: '未上传任何图片！',
type: 'text',
width:'3rem'
})
return
}
try {
await Api('UpdateOrderMeetingReceipt',{
ID: this.MeetingReceiptOrder.ID,
FeedBackPhotos: JSON.stringify(imageList)
})
await this.fetchOrderMeetingReceipt()
this.$forceUpdate()
this.$vux.toast.show({
text: '上传成功！',
type: 'text',
width:'3rem'
})
} catch (e) {
console.log(e)
}

},
handleMeetingReceiptSubmit() {
this.OrderMeetingReceiptShow = false
},
handleImageChange() {
this.changePrefixName()
},
handleImageCancel() {
},
handleImageSuccess(result, fileItem) {
fileItem.imgUrl = result.data[0]
},
handleImageError() {
this.$vux.toast.show({
text: '图片上传失败，请联系管理员',
type: 'cancel'
})
},
handleImageDelete(cb) {
let delIndex = -1
this.MeetingReceiptOrder.fileList.forEach((item, index) => {
if (item.imgUrl === cb.imgUrl) {
delIndex = index
}
})
this.MeetingReceiptOrder.fileList.splice(delIndex, 1)
},
changePrefixName() {
let oi = this.MeetingReceiptOrder.Order.OrderInfo
let omr = this.MeetingReceiptOrder
let index = this.MeetingReceiptOrder.fileList.length + 1
let meeting_id = this.MeetingReceiptOrder.Order.MeetingID
this.prefixName = `${omr.Name}(回传照片)-${oi.RegistryName}-${oi.RegistryContact}-${index}-${meeting_id}`
}
},
}
